export function normalizePath(inputPath: string): string {
  const trimmed = inputPath.trim().replace(/\\/g, "/")
  const noLeading = trimmed.replace(/^\/+/, "")
  const chunks = noLeading
    .split("/")
    .map((p) => p.trim())
    .filter(Boolean)

  const safe: string[] = []
  for (const chunk of chunks) {
    if (chunk === ".") continue
    if (chunk === "..") {
      if (safe.length > 0) safe.pop()
      continue
    }
    safe.push(chunk)
  }

  return safe.join("/")
}

export function isSafePath(inputPath: string): boolean {
  const normalized = normalizePath(inputPath)
  if (!normalized) return false
  return !normalized.split("/").some((segment) => segment === "..")
}

export function parentPath(inputPath: string): string {
  const normalized = normalizePath(inputPath)
  if (!normalized.includes("/")) return ""
  return normalized.split("/").slice(0, -1).join("/")
}

export function basename(inputPath: string): string {
  const normalized = normalizePath(inputPath)
  const parts = normalized.split("/")
  return parts[parts.length - 1] ?? ""
}

export function hasTrailingSlash(inputPath: string): boolean {
  return inputPath.endsWith("/")
}

const IMAGE_EXTENSIONS = [".png", ".jpg", ".jpeg", ".gif", ".bmp", ".webp", ".svg", ".ico"] as const

export function isImageMimeType(mimeType: string | undefined | null): boolean {
  if (!mimeType) return false
  return mimeType.trim().toLowerCase().startsWith("image/")
}

export function isImageFile(inputPath: string, mimeType?: string | null): boolean {
  if (isImageMimeType(mimeType)) return true
  const file = basename(inputPath).toLowerCase()
  return IMAGE_EXTENSIONS.some((ext) => file.endsWith(ext))
}

export function isAssetByExtension(inputPath: string): boolean {
  return isImageFile(inputPath)
}

/** True when file content can be used directly as an <img src>. */
export function isRenderableImageSrc(content: string | undefined | null): boolean {
  if (!content) return false
  const value = content.trim()
  return (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:image/") ||
    value.startsWith("blob:")
  )
}
